module.exports = __webpack_public_path__ + "static/andriy_maslijevych-88b3b7e52262f3b0be3c629d0ab983a2.png";